const labels: { [key: string]: string } = {
    title: "Woosmap Agent - Chatbot demo"
}

export default {
    labels: labels,
}